import { useEffect, useRef } from 'react';
import { ALL_EQUIPMENTS } from '../../../../shared/types/oeeRow.ts';
import { useResizeObserver } from '../../../hooks/useResizeObserver.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { drawReportGraph } from '../drawReportGraph.ts';
import { ReportGraphContainer } from '../reportGraphContainer.tsx';
import { ReportSettings } from '../report-settings/reportSettings.ts';
import { prepareScrapsRatios } from './prepareScrapsRatios.ts';


interface Props {
    style?: React.CSSProperties;
    reportSettings: ReportSettings;
    operatorFooterLabelsByPeriod?: string[][];
    onOperatorFooterClick?: (periodIndex: number) => void;
}

export function ScrapsRatioGraph({
    style,
    reportSettings,
    operatorFooterLabelsByPeriod,
    onOperatorFooterClick,
}: Props) {
    const graphContainerRef = useRef<HTMLDivElement>(null);
    const dimensions = useResizeObserver(graphContainerRef);


    const { data: oeeData, isFetching } = trpc.graphsData.getOee.useQuery({
        windowType: 'shift',
        equipment: ALL_EQUIPMENTS,
        start: reportSettings.first.start,
        end: reportSettings.last.end,
    }, { refetchOnWindowFocus: false, });

    useEffect(() => {
        if (graphContainerRef.current == null || oeeData == null) {
            return;
        }

        const data = prepareScrapsRatios(oeeData, reportSettings);
        drawReportGraph(graphContainerRef.current!, data, operatorFooterLabelsByPeriod, onOperatorFooterClick);
    }, [graphContainerRef, oeeData, reportSettings, operatorFooterLabelsByPeriod, onOperatorFooterClick, dimensions]);


    return (
        <ReportGraphContainer
            style={{ ...style, height: '100%' }}
            containerRef={graphContainerRef}
            isLoading={isFetching}
        />
    );
}
